import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from './CoroutineDispatcher.mjs';
import {
  checkParallelism305j5epqg3ju0 as checkParallelism,
  namedOrThis1pi8a62t67wtr as namedOrThis,
} from './internal/LimitedDispatcher.mjs';
import { invokeOnCancellationb68niwbjdmgy as invokeOnCancellation } from './CancellableContinuation.mjs';
import { Delay9umexudtwyie as Delay } from './Delay.mjs';
import { ArrayDeque2dzc9uld4xi7n as ArrayDeque } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayDeque.mjs';
import { removeFirstOrNull15yg2tczrh8a7 as removeFirstOrNull } from '../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Runnablezd7bpy5et5p0 as Runnable,
  Runnable$run$ref3om29tdwg29c8 as Runnable$run$ref,
} from './Runnable.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { coerceIn302bduskdb54x as coerceIn } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { boxApply1qmzdb3dh90hg as boxApply } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CancelHandler3ic7xysezxbm5 as CancelHandler } from './CancellableContinuationImpl.mjs';
import { DisposableHandle1uzxt8frdchxn as DisposableHandle } from './Job.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NodeDispatcherClass;
function NodeDispatcher() {
  if (NodeDispatcherClass === VOID) {
    class $ extends SetTimeoutBasedDispatcher() {
      constructor() {
        NodeDispatcher_instance = null;
        super();
        NodeDispatcher_instance = this;
      }
      y1k() {
        process.nextTick(this.f1l_1.d1l_1);
      }
    }
    initMetadataForObject($, 'NodeDispatcher', VOID, VOID, VOID, [1]);
    NodeDispatcherClass = $;
  }
  return NodeDispatcherClass;
}
var NodeDispatcher_instance;
function NodeDispatcher_getInstance() {
  if (NodeDispatcher_instance === VOID)
    new (NodeDispatcher())();
  return NodeDispatcher_instance;
}
var ScheduledMessageQueueClass;
function ScheduledMessageQueue() {
  if (ScheduledMessageQueueClass === VOID) {
    class $ extends MessageQueue() {
      constructor(dispatcher) {
        super();
        this.c1l_1 = dispatcher;
        var tmp = this;
        tmp.d1l_1 = () => {
          this.j1l();
          return Unit_instance;
        };
      }
      k1l() {
        this.c1l_1.y1k();
      }
      l1l() {
        setTimeout(this.d1l_1, 0);
      }
      m1l(timeout) {
        setTimeout(this.d1l_1, timeout);
      }
    }
    initMetadataForClass($, 'ScheduledMessageQueue');
    ScheduledMessageQueueClass = $;
  }
  return ScheduledMessageQueueClass;
}
function w3cSetTimeout(handler, timeout) {
  return setTimeout(handler, timeout);
}
var WindowMessageQueueClass;
function WindowMessageQueue() {
  if (WindowMessageQueueClass === VOID) {
    class $ extends MessageQueue() {
      constructor(window_0) {
        super();
        this.y1l_1 = window_0;
        this.z1l_1 = 'dispatchCoroutine';
        this.y1l_1.addEventListener('message', (event) => {
          var tmp;
          if (event.source == this.y1l_1 && event.data == this.z1l_1) {
            event.stopPropagation();
            this.j1l();
            tmp = Unit_instance;
          }
          return Unit_instance;
        }, true);
      }
      k1l() {
        var tmp = Promise.resolve(Unit_instance);
        tmp.then((it) => {
          this.j1l();
          return Unit_instance;
        });
      }
      l1l() {
        this.y1l_1.postMessage(this.z1l_1, '*');
      }
    }
    initMetadataForClass($, 'WindowMessageQueue');
    WindowMessageQueueClass = $;
  }
  return WindowMessageQueueClass;
}
function w3cSetTimeout_0(window_0, handler, timeout) {
  return setTimeout_0(window_0, handler, timeout);
}
function w3cClearTimeout(window_0, handle) {
  return window_0.clearTimeout(handle);
}
function w3cClearTimeout_0(handle) {
  return clearTimeout(handle);
}
function setTimeout_0(window_0, handler, timeout) {
  return window_0.setTimeout(handler, timeout);
}
var SetTimeoutDispatcherClass;
function SetTimeoutDispatcher() {
  if (SetTimeoutDispatcherClass === VOID) {
    class $ extends SetTimeoutBasedDispatcher() {
      constructor() {
        SetTimeoutDispatcher_instance = null;
        super();
        SetTimeoutDispatcher_instance = this;
      }
      y1k() {
        this.f1l_1.m1l(0);
      }
    }
    initMetadataForObject($, 'SetTimeoutDispatcher', VOID, VOID, VOID, [1]);
    SetTimeoutDispatcherClass = $;
  }
  return SetTimeoutDispatcherClass;
}
var SetTimeoutDispatcher_instance;
function SetTimeoutDispatcher_getInstance() {
  if (SetTimeoutDispatcher_instance === VOID)
    new (SetTimeoutDispatcher())();
  return SetTimeoutDispatcher_instance;
}
var SetTimeoutBasedDispatcherClass;
function SetTimeoutBasedDispatcher() {
  if (SetTimeoutBasedDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor() {
        super();
        this.f1l_1 = new (ScheduledMessageQueue())(this);
      }
      r13(parallelism, name) {
        checkParallelism(parallelism);
        return namedOrThis(this, name);
      }
      t13(context, block) {
        this.f1l_1.n1l(block);
      }
      i14(timeMillis, block, context) {
        var handle = w3cSetTimeout(() => {
          block.p12();
          return Unit_instance;
        }, delayToInt(timeMillis));
        return new (ClearTimeout())(handle);
      }
      h14(timeMillis, continuation) {
        var handle = w3cSetTimeout(() => {
          // Inline function 'kotlin.with' call
          continuation.d10(this, Unit_instance);
          return Unit_instance;
        }, delayToInt(timeMillis));
        invokeOnCancellation(continuation, new (ClearTimeout())(handle));
      }
    }
    initMetadataForClass($, 'SetTimeoutBasedDispatcher', VOID, VOID, [Delay()], [1]);
    SetTimeoutBasedDispatcherClass = $;
  }
  return SetTimeoutBasedDispatcherClass;
}
var MessageQueueClass;
function MessageQueue() {
  if (MessageQueueClass === VOID) {
    class $ {
      constructor() {
        this.g1l_1 = ArrayDeque().wj();
        this.h1l_1 = 16;
        this.i1l_1 = false;
      }
      n1l(element) {
        this.o1l(element);
        if (!this.i1l_1) {
          this.i1l_1 = true;
          this.k1l();
        }
      }
      j1l() {
        try {
          // Inline function 'kotlin.repeat' call
          var times = this.h1l_1;
          var inductionVariable = 0;
          if (inductionVariable < times)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp0_elvis_lhs = removeFirstOrNull(this);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                return Unit_instance;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var element = tmp;
              element.p12();
            }
             while (inductionVariable < times);
        }finally {
          if (this.n1()) {
            this.i1l_1 = false;
          } else {
            this.l1l();
          }
        }
      }
      o1l(element) {
        return this.g1l_1.j2(element);
      }
      j2(element) {
        return this.o1l((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      p1l(index, element) {
        this.g1l_1.z4(index, element);
      }
      z4(index, element) {
        return this.p1l(index, (!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      q1l(elements) {
        return this.g1l_1.u2(elements);
      }
      u2(elements) {
        return this.q1l(elements);
      }
      y4() {
        this.g1l_1.y4();
      }
      r1l(index, element) {
        return this.g1l_1.j3(index, element);
      }
      j3(index, element) {
        return this.r1l(index, (!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      a5(index) {
        return this.g1l_1.a5(index);
      }
      v2(index) {
        return this.g1l_1.v2(index);
      }
      b3(fromIndex, toIndex) {
        return this.g1l_1.b3(fromIndex, toIndex);
      }
      n1() {
        return this.g1l_1.n1();
      }
      s1l(element) {
        return this.g1l_1.t2(element);
      }
      t2(element) {
        if (!(!(element == null) ? isInterface(element, Runnable()) : false))
          return false;
        return this.s1l((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      p1() {
        return this.g1l_1.p1();
      }
      t1l(elements) {
        return this.g1l_1.r4(elements);
      }
      r4(elements) {
        return this.t1l(elements);
      }
      r2(index) {
        return this.g1l_1.r2(index);
      }
      u1l(element) {
        return this.g1l_1.s4(element);
      }
      s4(element) {
        if (!(!(element == null) ? isInterface(element, Runnable()) : false))
          return -1;
        return this.u1l((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      q2() {
        return this.g1l_1.tj_1;
      }
    }
    initMetadataForClass($, 'MessageQueue', VOID, VOID, [KtMutableList()]);
    MessageQueueClass = $;
  }
  return MessageQueueClass;
}
var WindowClearTimeoutClass;
function WindowClearTimeout() {
  if (WindowClearTimeoutClass === VOID) {
    class $ extends ClearTimeout() {
      constructor($outer, handle, $box) {
        if ($box === VOID)
          $box = {};
        $box.t1m_1 = $outer;
        super(handle, $box);
      }
      n10() {
        w3cClearTimeout(this.t1m_1.v1m_1, this.x1m_1);
      }
    }
    initMetadataForClass($, 'WindowClearTimeout');
    WindowClearTimeoutClass = $;
  }
  return WindowClearTimeoutClass;
}
var WindowDispatcherClass;
function WindowDispatcher() {
  if (WindowDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor(window_0) {
        super();
        this.v1m_1 = window_0;
        this.w1m_1 = new (WindowMessageQueue())(this.v1m_1);
      }
      t13(context, block) {
        return this.w1m_1.n1l(block);
      }
      h14(timeMillis, continuation) {
        var handle = w3cSetTimeout_0(this.v1m_1, () => {
          // Inline function 'kotlin.with' call
          continuation.d10(this, Unit_instance);
          return Unit_instance;
        }, delayToInt(timeMillis));
        invokeOnCancellation(continuation, new (WindowClearTimeout())(this, handle));
      }
      i14(timeMillis, block, context) {
        var handle = w3cSetTimeout_0(this.v1m_1, Runnable$run$ref(block), delayToInt(timeMillis));
        return new (WindowClearTimeout())(this, handle);
      }
    }
    initMetadataForClass($, 'WindowDispatcher', VOID, VOID, [Delay()], [1]);
    WindowDispatcherClass = $;
  }
  return WindowDispatcherClass;
}
function delayToInt(timeMillis) {
  return convertToInt(coerceIn(timeMillis, 0n, 2147483647n));
}
var ClearTimeoutClass;
function ClearTimeout() {
  if (ClearTimeoutClass === VOID) {
    class $ {
      constructor(handle, $box) {
        boxApply(this, $box);
        this.x1m_1 = handle;
      }
      n10() {
        w3cClearTimeout_0(this.x1m_1);
      }
      m10(cause) {
        this.n10();
      }
      toString() {
        return 'ClearTimeout[' + this.x1m_1 + ']';
      }
    }
    initMetadataForClass($, 'ClearTimeout', VOID, VOID, [CancelHandler(), DisposableHandle()]);
    ClearTimeoutClass = $;
  }
  return ClearTimeoutClass;
}
//region block: exports
export {
  NodeDispatcher_getInstance as NodeDispatcher_getInstance1gcng8nkmandy,
  SetTimeoutDispatcher_getInstance as SetTimeoutDispatcher_getInstance2vkq12hdscb97,
  WindowDispatcher as WindowDispatcheram3q94j2gxvn,
};
//endregion

//# sourceMappingURL=JSDispatcher.mjs.map
